<template>
  <div class="testimonial">
    <div class="body">
      &quot;{{quote}}&quot;
    </div>
    <div class="footer">
      <img v-bind:src="imgUrl" alt="testimonial avatar"/>
      <div class="details">
        <div class="name">{{name}}</div>
        <div class="title">{{title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'testimonial',
    props: {
      imgUrl: String,
      name: String,
      title: String,
      linkedin: String,
      quote: String
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  .testimonial {

    border-top: 4px solid $slide-blue;
    width: 284px;
    margin: auto;
    box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 13px;
    border-bottom-right-radius: 13px;

    .body {
      height: 220px;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.6em;
      padding: 38px 16px;
      background: $white;
    }

    .footer {
      height: 100px;
      overflow: hidden;
      background: $slide-blue;
      color: $white;
      border-bottom-left-radius: 13px;
      border-bottom-right-radius: 13px;

      img {
        float: left;
        width: 45px;
        height: 45px;
        border-radius: 25px;
        margin: 21px 19px;
      }

      .details {
        margin-top: 23px;
        float: left;
        text-align: left;

        .name {
          font-size: 16px;
        }

        .title {
          font-size: 12px;
        }

        .title::first-letter {
          text-transform: capitalize;
        }
      }
    }
  }
</style>
